export default "__VITE_ASSET__CGqJRuE8__"